import React from 'react';

import downloadDocument from '../../../../../../../helpers/downloadDocument';

import { useUiContext } from '../../../../../../../context/UiContext';

export default function DocumentActions({
  row,
  updateInsuranceWithDocuments,
  insurance,
  readOnly,
}) {
  const { showToast, showDialogModal } = useUiContext();

  const download = () => {
    try {
      downloadDocument(
        row.document_id,
        `${row._document?.private_document?.name}.pdf`
      );
    } catch (error) {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    }
  };

  const deleteDocument = async () => {
    showDialogModal({
      title: 'Are you sure want to delete this document?',
      type: 'danger',
      onConfirm: () =>
        updateInsuranceWithDocuments({
          formValues: {
            ...insurance,
            documents: insurance.documents.filter(
              (doc) =>
                !(doc.document_id === row.document_id && doc.type === row.type)
            ),
          },
          message: 'Document deleted',
        }),
    });
  };

  return (
    <div className="flex gap-5">
      <button
        type="button"
        className="btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-slate-600 dark:text-slate-300"
        onClick={download}
      >
        Download
      </button>
      {!readOnly && (
        <button
          type="button"
          className="btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-rose-500"
          onClick={deleteDocument}
        >
          Delete
        </button>
      )}
    </div>
  );
}
